import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';

/**
 * Generated class for the ParticipantPropertiesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-participant-properties',
  templateUrl: 'participantProperties.html',
})
export class ParticipantPropertiesPage {

  public participant:object;

  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              public events: Events) {

    this.participant = navParams.data;
    this.events.subscribe("participantProperties:participantChanged", (participant)=>{
      console.log("participant changed!", participant);
      this.participant= participant;
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ParticipantPropertiesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/participantProperties/participantProperties.ts